<div class="container-fluid">
    <div class="row justify-content-start">
      <div class="col-sm-5">
        <h4 class="title"><p>Facility Data Export</p></h4>
        <div class="form-group">
          
          <div class="downloadmsg" *ngIf="displayRawDataMessage">
            <span>You can download 4 Quarters of data.</span>
          </div>
    
          <!--Below message will never be used since we only have exports for raw data: exportId=1-->
          <!-- <div class="downloadmsg" *ngIf="displayCalculatedRatesMessage">
            <span>All calculated rates are based on Year/Quarter report production. You can download data for latest 12
              reporting quarters.</span>
          </div> -->
        </div>
    
        <!-- <div class="pb-5" *ngIf="selectedExportID"> -->
            <div class="pb-5">
          <div class="row justify-content-between">
            <div *ngIf="showDateValidation" class="error-message">{{errorMessage}}</div>
            <div class="col-sm-6">
              <div class="row">
                <div class="col-sm-6">
                  <!-- From Year  -->
                  <label>From Year</label>
                  <select class="form-control" style="font-size:14px" (change)="onStartYearSelectionChange($event.target.value)"
                    [value]="selectedStartYear">
                    <option *ngFor="let year of availableYears" 
                            [value]=year
                            [selected]="year == selectedStartYear">
                      {{year}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <!-- From Qtr  -->
                  <label>Quarter</label>
                  <select class="form-control" style="font-size:14px" (change)="onStartQuarterSelectionChange($event.target.value)"
                    [value]="selectedStartQuarter">
                    <option *ngFor="let qtr of availableStartQuarters" 
                            [value]=qtr
                            [selected]="qtr == selectedStartQuarter">
                      {{qtr}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
    
            <div class="col-sm-6">
              <div class="row">
                <div class="col-sm-6">
                  <!-- To Year  -->
                  <label>To Year</label>
                  <select class="form-control" style="font-size:14px"  (change)="onEndYearSelectionChange($event.target.value)"
                    [value]="selectedEndYear">
                    <option *ngFor="let year of availableYears" 
                            [value]=year
                            [selected]="year == selectedEndYear">
                      {{year}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <!-- To Qtr  -->
                  <label>Quarter</label>
                  <select class="form-control" style="font-size:14px" (change)="onEndQuarterSelectionChange($event.target.value)"
                    [value]="selectedEndQuarter">
                    <option *ngFor="let endqtr of availableEndQuarters" 
                            [value]=endqtr
                            [selected]="endqtr == selectedEndQuarter">
                      {{endqtr}}
                    </option>
                  </select>
                </div>
              </div>
    
            </div>
          </div>
        </div>
    
        <div class="pt-5">
          <button (click)="onExportClicked()" type="submit" [disabled]=isExportDisabled() class="btn btn-primary customPrimaryBTN"
            title="generate export file">Export</button>
        </div>
        <div class="downloadmsg" *ngIf="displayExportRequestedMessage">
          <span [ngClass]="getMessageClass()">{{exportRequestedMessage}}</span>
        </div>
        <div class="downloadmsg" *ngIf="dispayRefreshMessage">
          <span>Your data export generation has been scheduled. You may log out or continue to work in other areas of the NDNQI website. Push the Refresh button to see updated Status.</span>
        </div>
      </div>
    </div>
    </div>
